export const SET_MEMBER_DETAILS = 'SET_MEMBER_DETAILS'
export const SET_MEMBER_DETAILS_LOADING = 'SET_MEMBER_DETAILS_LOADING'
export const BEGIN_LOADING_MEMBER_DETAILS = 'BEGIN_LOADING_MEMBER_DETAILS'
export const SET_MEMBER_ADDRESSES = 'SET_MEMBER_ADDRESSES'
export const BEGIN_LOADING_MEMBER_ADDRESSES = 'BEGIN_LOADING_MEMBER_ADDRESSES'
export const SET_MEMBER_TRANSACTIONS = 'SET_MEMBER_TRANSACTIONS'
export const SET_MEMBER_TRANSACTIONS_ERROR = 'SET_MEMBER_TRANSACTIONS_ERROR'
export const SET_MEMBER_TRANSACTION_DRAFTS = 'SET_MEMBER_TRANSACTION_DRAFTS'
export const BEGIN_LOADING_MEMBER_TRANSACTIONS = 'BEGIN_LOADING_MEMBER_TRANSACTIONS'
export const SET_UPDATING_MEMBER = 'SET_UPDATING_MEMBER'
export const SET_MEMBER_TRANSACTION_DETAILS_LOADING = 'SET_MEMBER_TRANSACTION_DETAILS_LOADING'
export const SET_ACTIVE_BENEFIT_CATEGORY_INDEX = 'SET_ACTIVE_BENEFIT_CATEGORY_INDEX'
